module.exports = __webpack_public_path__ + "52a2a29c0f6209b56821aaa5de9f31dc.pdf";